import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { AngularIbanModule } from 'angular-iban';
import { MY_DATE_FORMAT } from './app/date-format';
import { environment } from './environments/environment';

import { provideRouter, Routes, withComponentInputBinding } from '@angular/router';
import { VisitsComponent } from './app/components/visits/visits.component';
import { RegistrationListComponent } from './app/components/registrations/registration-list/registration-list.component';
import { RegistrationWizardComponent } from './app/components/registrations/registration-wizard/registration-wizard.component';
import { StudentListComponent } from './app/components/students/student-list/student-list.component';
import { CourseListComponent } from './app/components/courses/course-list/course-list.component';
import { AuthInterceptor } from './app/services/authentication/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './app/services/authentication/auth.guard';
import { LoginComponent } from './app/components/login/login.component';
import { CheckinDisplayComponent } from './app/components/checkin/checkin-display/checkin-display.component';
import { DisplaysComponent } from './app/components/checkin/displays/displays.component';
import { TrialsComponent } from './app/components/checkin/trials/trials.component';

const publicRoutes: Routes = [
  { path: '', component: RegistrationWizardComponent },
  { path: '**', redirectTo: '' }
];

const internalRoutes: Routes = [
  { path: 'login', component: LoginComponent },

  { path: '', redirectTo: 'students', pathMatch: 'full' },
  { path: 'students', component: StudentListComponent, canActivate: [AuthGuard] },
  { path: 'visits', component: VisitsComponent, canActivate: [AuthGuard] },
  { path: 'courses', component: CourseListComponent, canActivate: [AuthGuard] },
  { path: 'registrations', component: RegistrationListComponent, canActivate: [AuthGuard] },
  { path: 'visits/:date/:time', component: VisitsComponent, canActivate: [AuthGuard] },
  { path: 'trials', component: TrialsComponent, canActivate: [AuthGuard] },
  { path: 'displays', component: DisplaysComponent, canActivate: [AuthGuard] },
  // Check-in display on a tablet: own login (display token), no back office session.
  { path: 'checkin/:pid', component: CheckinDisplayComponent },

  { path: '**', redirectTo: 'login' }
];

const routes: Routes = environment.lite ? publicRoutes : internalRoutes;


bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withComponentInputBinding()),
    importProvidersFrom(
      BrowserAnimationsModule,
      FormsModule,
      ReactiveFormsModule,
      MatTableModule,
      MatPaginatorModule,
      MatProgressSpinnerModule,
      MatDatepickerModule,
      MatFormFieldModule,
      MatNativeDateModule,
      MatRippleModule,
      MatStepperModule,
      MatInputModule,
      MatButtonModule,
      MatRadioModule,
      MatSelectModule,
      MatCheckboxModule,
      MatTooltipModule,
      MatIconModule,
      AngularIbanModule
    ),
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ]
});
